<template>
  <MainLayout>
    <div class="container mw-960" slot="action-bar">
      <div class="row">
        <div class="col-12">
          <button type="button"
                  class="class-manage-btn btn btn-outline-primary close-btn mr-2"
                  v-on:click="openStudentManageModal">
            {{ $t('reports.manage_class_students') }}
          </button>
          <h5 class="action-header typography--headline typography--color-secondary pt-1 pl-10-mobile pr-10-mobile pb-12">{{ formattedClassName }}</h5>
          <div class="mr-12 clickable" v-bind:class="{'class-report-menu-selected': selectedReport === 1, 'class-report-menu-nonselected': selectedReport !== 1}"
               v-on:click="selectedReport = 1">{{ $t('reports.subject_study_status') }}</div>
          <div class="clickable" v-bind:class="{'class-report-menu-selected': selectedReport === 2, 'class-report-menu-nonselected': selectedReport !== 2}"
               v-on:click="selectedReport = 2">{{ $t('reports.all_study_status') }}</div>
        </div>
      </div>
    </div>

    <div class="container mw-960 mt-15" slot="layout-body">
      <div class="row pt-3" v-if="loading">
        <div class="col-12 text-center">
          <LoadingBounce></LoadingBounce>
          <div class="typography--body-2 typography--color-disabled pb-5">{{ $t('common.loading') }}</div>
        </div>
      </div>

      <div v-else>
        <div v-if="selectedReport === 1">
          <div>
            <b-dropdown v-bind:text="getTranslatedName(subjectMap[selectedSubjectId])" class="select-subject-dropdown mnv-dropdown">
              <b-dropdown-item v-for="subjectId in subjectIds" v-on:click="selectedSubjectId = parseInt(subjectId, 10)">{{ getTranslatedName(subjectMap[subjectId]) }}</b-dropdown-item>
            </b-dropdown>

            <button class="btn btn-outline-rectangle select-assignment-btn" @click="selectAssignmentModalIsShown = true">
              {{ $t('reports.select_assignments') }}
            </button>

            <div v-on:click="selectedStudentReport = 1; sortType = 'number';" class="text-center mr-6 clickable"
                 v-bind:class="{'student-report-select': selectedStudentReport === 1, 'student-report-nonselect': selectedStudentReport !== 1}">
              {{ $t('reports.need_help_students') }} &nbsp;<span class="typography--font-weight-bold">{{ getNumStrTwoDigit(needHelpStudentList.length) }}</span>
            </div>
            <div v-on:click="selectedStudentReport = 2; sortType = 'number';" class=" text-center clickable"
                 v-bind:class="{'student-report-select': selectedStudentReport === 2, 'student-report-nonselect': selectedStudentReport !== 2}">
              {{ $t('reports.all_students_report') }} &nbsp;<span class="typography--font-weight-bold">{{ getNumStrTwoDigit(studentList.length) }}</span>
            </div>

            <div class="report-students-info mt-27">
              <div class="report-students-info-sort typography--color-secondary">
                <div v-bind:class="{'sort-active': sortType === 'number'}" class="display-inlineblock clickable right-border" v-on:click="sortType = 'number'">
                  {{ $t('reports.sort_number') }}&nbsp;&nbsp;</div>
                <div v-bind:class="{'sort-active': sortType === 'score'}" class="display-inlineblock clickable" v-on:click="sortType = 'score'">
                  &nbsp;{{ $t('reports.sort_rank') }}
                </div>
              </div>

              <div class="report-students-info-title" v-if="selectedStudentReport === 1">
                {{ $t('reports.need_help_students') }} &nbsp;<span class="typography--font-weight-bold">{{ getNumStrTwoDigit(needHelpStudentList.length) }}</span>
              </div>
              <div class="report-students-info-title" v-if="selectedStudentReport === 2">
                {{ $t('reports.all_students_report') }} &nbsp;<span class="typography--font-weight-bold">{{ getNumStrTwoDigit(studentList.length) }}</span>
              </div>

              <div class="card-block row" v-if="selectedStudentReport === 1">
                <Card class="report-students-card" v-for="(student, index) in needHelpStudentList" v-if="viewMoreNeedHelp || index < viewMoreLength">
                  <div class="report-students-card-header clickable" v-on:click="$router.push(`/reports/classes/${cls.id}/students/${student.student_id}?subject_id=${selectedSubjectId}`)">
                    <div v-bind:class="{'report-students-card-header-time': getTotalDuration(student.submissions) !== 0,
                            'report-students-card-header-time-disabled': getTotalDuration(student.submissions) === 0}">
                      <img src="/static/images/time-icon.svg" v-if="getTotalDuration(student.submissions) !== 0">
                      <img src="/static/images/time-gray-icon.svg" v-else>
                      {{ formattedTime(getTotalDuration(student.submissions)) }}
                    </div>
                    <div class="student-number">{{ getNumStrTwoDigit(student.number) }}</div>&nbsp;
                    <div class="student-name">{{ student.name }}</div>
                  </div>
                  <div class="report-students-card-body clickable">
                    <div v-on:click="$router.push(`/reports/classes/${cls.id}/students/${student.student_id}?subject_id=${selectedSubjectId}`)">
                      <div class="report-students-card-body-titles">
                        {{ $t('reports.table.score') }}<br>
                        {{ $t('common.rank') }}<br><br>
                        {{ $t('reports.table.complete_rate') }}
                      </div>
                      <div class="report-students-card-body-contents">
                        <div class="typography--font-weight-bold rank-left" v-if="getSubmissionSubjectScore(student.submissions, selectedSubjectId) === null">-</div>
                        <div class="typography--font-weight-bold rank-left" v-else>{{ getSubmissionSubjectScore(student.submissions, selectedSubjectId) }}</div><br>
                        <div class="typography--font-weight-bold rank-left">
                            <span v-if="classSubjectScoreRanks.indexOf(getSubmissionSubjectScore(student.submissions, selectedSubjectId)) >= 0">
                              {{ classSubjectScoreRanks.indexOf(getSubmissionSubjectScore(student.submissions, selectedSubjectId)) + 1 }} {{ $t('reports.rank_suffix') }}
                            </span>
                          <span v-else>-</span>
                        </div> | &nbsp; {{ studentList.length }}<br><br>
                        <div class="typography--font-weight-bold rank-left">{{ getCompleteRateSubject(student.submissions, selectedSubjectId) || 0 }}%</div>
                      </div>
                    </div>
                    <br>
                    <div class="report-students-card-footer clickable"
                         v-on:click="studentToRecommend = student; openRecommendContentModal();">{{ $t('reports.go_to_recommend_contents') }}</div>
                  </div>
                </Card>

                <Card class="report-students-no-card" v-if="needHelpStudentList.length === 0">
                  <div class="row no-need-help-container">
                    <img src="/static/images/friends-img.png">
                    <div class="no-need-help-text">
                      <span class="no-need-help-text1">{{ $t('reports.no_need_help_students') }}</span><br>
                      <span class="no-need-help-text2">{{ $t('reports.students_well_following') }}</span>
                    </div>
                  </div>
                </Card>
              </div>
              <div class="view-more-container text-center" v-if="selectedStudentReport === 1 && needHelpStudentList.length > viewMoreLength"
                   v-on:click="viewMoreNeedHelp = !viewMoreNeedHelp">
                <span v-if="!viewMoreNeedHelp">{{ $t('common.view_more') }}</span>
                <span v-else>{{ $t('common.view_less') }}</span>
                &nbsp;&nbsp;
                <img v-if="!viewMoreNeedHelp" src="/static/images/arrow-down.svg">
                <img v-else src="/static/images/arrow-up.svg">
              </div>

              <div class="card-block row" v-if="selectedStudentReport === 2">
                <Card class="report-students-card" v-for="(student, index) in sortedStudentList" v-if="viewMoreTotalStudents || index < viewMoreLength">
                  <div class="report-students-card-header clickable" v-on:click="$router.push(`/reports/classes/${cls.id}/students/${student.student_id}?subject_id=${selectedSubjectId}`)">
                    <div v-bind:class="{'report-students-card-header-time': getTotalDuration(student.submissions) !== 0,
                            'report-students-card-header-time-disabled': getTotalDuration(student.submissions) === 0}">
                      <img src="/static/images/time-icon.svg" v-if="getTotalDuration(student.submissions) !== 0">
                      <img src="/static/images/time-gray-icon.svg" v-else>
                      {{ formattedTime(getTotalDuration(student.submissions)) }}
                    </div>
                    <div class="student-number">{{ getNumStrTwoDigit(student.number) }}</div>&nbsp;
                    <div class="student-name">{{ student.name }}</div>
                  </div>
                  <div class="report-students-card-body clickable" v-on:click="$router.push(`/reports/classes/${cls.id}/students/${student.student_id}?subject_id=${selectedSubjectId}`)">
                    <div>
                      <div class="report-students-card-body-titles">
                        {{ $t('reports.table.score') }}<br>
                        {{ $t('common.rank') }}<br><br>
                        {{ $t('reports.table.complete_rate') }}
                      </div>
                      <div class="report-students-card-body-contents">
                        <div class="typography--font-weight-bold rank-left" v-if="getSubmissionSubjectScore(student.submissions, selectedSubjectId) === null">-</div>
                        <div class="typography--font-weight-bold rank-left" v-else>{{ getSubmissionSubjectScore(student.submissions, selectedSubjectId) }}</div><br>
                        <div class="typography--font-weight-bold rank-left">
                            <span v-if="classSubjectScoreRanks.indexOf(getSubmissionSubjectScore(student.submissions, selectedSubjectId)) >= 0">
                              {{ classSubjectScoreRanks.indexOf(getSubmissionSubjectScore(student.submissions, selectedSubjectId)) + 1 }} {{ $t('reports.rank_suffix') }}
                            </span>
                          <span v-else>-</span>
                        </div> | &nbsp; {{ studentList.length }}<br><br>
                        <div class="typography--font-weight-bold rank-left">{{ getCompleteRateSubject(student.submissions, selectedSubjectId) || 0 }}%</div>
                      </div>
                    </div>
                    <br>
                  </div>
                </Card>
              </div>
              <div class="view-more-container text-center" v-if="selectedStudentReport === 2 && studentList.length > viewMoreLength"
                   v-on:click="viewMoreTotalStudents = !viewMoreTotalStudents">
                <span v-if="!viewMoreTotalStudents">{{ $t('common.view_more') }}</span>
                <span v-else>{{ $t('common.view_less') }}</span>
                &nbsp;&nbsp;
                <img v-if="!viewMoreTotalStudents" src="/static/images/arrow-down.svg">
                <img v-else src="/static/images/arrow-up.svg">
              </div>
            </div>

            <div>
              <div class="card-row mb-12">
                <div class="row ml-0 mr-0">
                  <Card class="graph-summary-stat-container">
                    <div class="row pl-10 graph-header">
                      <div class="graph-summary-stat" v-if="selectedGraph === 1">
                        <span>{{ $t('reports.all_students_count') }}</span><br>
                        <span class="total-students-number">{{ studentList.length }}{{ $t('common.modal.preview.count') }}</span>
                      </div>

                      <div class="graph-summary-stat" v-if="selectedGraph === 2">
                        <div class="avg-score">
                          {{ $t('reports.average_score') }}
                          <div class="show-when-narrow">
                            <img src="/static/images/arrow-up.svg" v-if="diffAvgScore > 0">
                            <img src="/static/images/non-arrow.svg" v-if="diffAvgScore === 0">
                            <img src="/static/images/arrow-down.svg" v-if="diffAvgScore < 0">
                          </div>
                          <br>
                          <span class="avg-score-text">{{ currentAvgScore }}점</span>
                          <div class="show-when-wide">
                            <img src="/static/images/arrow-up.svg" v-if="diffAvgScore > 0">
                            <img src="/static/images/non-arrow.svg" v-if="diffAvgScore === 0">
                            <img src="/static/images/arrow-down.svg" v-if="diffAvgScore < 0">
                          </div>
                          <span class="diff-text">{{ getNumStrTwoDigit(Math.abs(diffAvgScore)) }}</span><br>
                        </div>
                        <div class="avg-submit-rate">
                          {{ $t('reports.submit_assignment') }}
                          <div class="show-when-narrow">
                            <img src="/static/images/arrow-up.svg" v-if="diffSubmissionRate > 0">
                            <img src="/static/images/non-arrow.svg" v-if="diffSubmissionRate === 0">
                            <img src="/static/images/arrow-down.svg" v-if="diffSubmissionRate < 0">
                          </div>
                          <br>
                          <span class="avg-submit-text">{{ currentSubmissionRate || 0}}%</span>
                          <div class="show-when-wide">
                            <img src="/static/images/arrow-up.svg" v-if="diffSubmissionRate > 0">
                            <img src="/static/images/non-arrow.svg" v-if="diffSubmissionRate === 0">
                            <img src="/static/images/arrow-down.svg" v-if="diffSubmissionRate < 0">
                          </div>
                          <span class="diff-text">{{ getNumStrTwoDigit(Math.abs(diffSubmissionRate || 0)) }}</span>
                        </div>
                      </div>

                      <div class="btn-selectgraph clickable"
                           v-bind:class="{'btn-rectangle-primary': selectedGraph === 1, 'typography--color-secondary': selectedGraph !== 1, 'btn-outline-rectangle-disabled': selectedGraph !== 1}"
                           v-on:click="selectedGraph = 1">{{ $t('reports.achievement') }}</div>
                      <div class="btn-selectgraph clickable"
                           v-bind:class="{'btn-rectangle-primary': selectedGraph === 2, 'typography--color-secondary': selectedGraph !== 2, 'btn-outline-rectangle-disabled': selectedGraph !== 2}"
                           v-on:click="selectedGraph = 2">{{ $t('reports.achievement_trend') }}</div>
                    </div>

                    <BarChart v-if="selectedGraph === 1" v-bind:height="150" v-bind:chartData="achievementDistribution" v-bind:totalStudents="studentList.length"></BarChart>
                    <LineChart v-if="selectedGraph === 2" v-bind:height="150" v-bind:chartData="trendData"></LineChart>
                  </Card>
                  <Card class="study-state">
                    <div class="study-state-title">{{ $t('reports.study_status') }}</div>
                    <div class="study-state-time">
                      <DoughnutChart v-bind:chartData="activeStudentData"></DoughnutChart>
                      <div class="study-state-time-text1 text-center">
                        <span class="bold-number">{{ getNumStrTwoDigit(Math.floor(getAverageDuration(getSubmissionsThisWeek(submissionsBySubjects[selectedSubjectId])) / 3600)) }}</span>h
                        <span class="bold-number">{{ getNumStrTwoDigit(Math.ceil(getAverageDuration(getSubmissionsThisWeek(submissionsBySubjects[selectedSubjectId])) / 60 % 60)) }}</span>m
                      </div>
                      <div class="study-state-time-text2 text-center">
                        {{ $t('reports.last_week_avg_time') }}<br>
                        <span class="typography--font-weight-bold">{{ getNumStrTwoDigit(Math.floor(getAverageDuration(getSubmissionsUntilLastWeek(submissionsBySubjects[selectedSubjectId])) / 3600)) }}</span>h
                        <span class="typography--font-weight-bold">{{ getNumStrTwoDigit(Math.ceil(getAverageDuration(getSubmissionsUntilLastWeek(submissionsBySubjects[selectedSubjectId])) / 60 % 60)) }}</span>m
                      </div>
                    </div>
                    <div class="ws-nowrap pb-6 font-14">
                      <div class="active-legend"></div>{{ $t('reports.active_students') }} &nbsp; <span class="bold-number">{{ getNumStrTwoDigit(getActiveStudents()) }}</span><br>
                    </div>
                    <div class="ws-nowrap font-14">
                      <div class="inactive-legend"></div>{{ $t('reports.inactive_students') }} &nbsp; <span class="bold-number">{{ getNumStrTwoDigit(studentList.length - getActiveStudents()) }}</span>
                    </div>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-else>
          <div class="class-report-allsubs">
            <table class="mw-960">
              <tbody>
              <tr>
                <td></td>
                <th class="clickable" v-for="subjectId in subjectIds" v-on:click="selectedSubjectId = subjectId; selectedReport = 1;">{{ getTranslatedName(subjectMap[subjectId]) }}</th>
              </tr>
              <tr>
                <td>{{ $t('reports.avg_score') }}</td>
                <td v-for="subjectId in subjectIds">
                  <div class="typography--font-weight-bold"
                       v-bind:class="{'color-00c896': diffScoreBySubjects[subjectId] > 0,
                      'color-f97e76': diffScoreBySubjects[subjectId] < 0}">
                    {{ averageScoreBySubjects[subjectId] }}
                  </div>
                  <span class="font-12"
                        v-bind:class="{'diff-up': diffScoreBySubjects[subjectId] > 0,
                    'diff-neutral': diffScoreBySubjects[subjectId] === 0,
                    'diff-down': diffScoreBySubjects[subjectId] < 0}">
                    {{ formattedDiff(diffScoreBySubjects[subjectId]) }}</span>
                </td>
              </tr>
              <tr>
                <td>{{ $t('reports.average_duration') }}</td>
                <td v-for="subjectId in subjectIds">
                  <span v-bind:class="{'time-up': diffDurationBySubjects[subjectId] > 0, 'time-down': diffDurationBySubjects[subjectId] < 0}">
                    <span class="typography--font-weight-bold">{{ getNumStrTwoDigit(Math.floor(averageDurationBySubjects[subjectId] / 3600)) }}</span>h
                    <span class="typography--font-weight-bold">{{ getNumStrTwoDigit(Math.ceil(averageDurationBySubjects[subjectId] / 60 % 60))}}</span>m
                  </span><br>
                  <img src="/static/images/red-time-icon.svg" v-if="diffDurationBySubjects[subjectId] < 0">
                  <img src="/static/images/non-time-icon.svg" v-if="diffDurationBySubjects[subjectId] === 0">
                  <img src="/static/images/grn-time-icon.svg" v-if="diffDurationBySubjects[subjectId] > 0"><br>
                  <span class="font-12"
                        v-bind:class="{'color-00c896': diffDurationBySubjects[subjectId] > 0,
                    'color-f97e76': diffDurationBySubjects[subjectId] < 0}">
                    {{ formattedTime(diffDurationBySubjects[subjectId]) }}
                  </span>
                </td>
              </tr>
              <tr>
                <td>{{ $t('reports.complete_rate') }}</td>
                <td v-for="subjectId in subjectIds">
                  <div class="typography--font-weight-bold"
                       v-bind:class="{'color-00c896': diffSubmitrateBySubjects[subjectId] > 0,
                      'color-f97e76': diffSubmitrateBySubjects[subjectId] < 0}">
                    {{ averageSubmitrateBySubjects[subjectId] }}
                  </div>
                  <span class="font-12"
                        v-bind:class="{'diff-up': diffSubmitrateBySubjects[subjectId] > 0,
                    'diff-neutral': diffSubmitrateBySubjects[subjectId] === 0,
                    'diff-down': diffSubmitrateBySubjects[subjectId] < 0}">
                    {{ formattedDiff(diffSubmitrateBySubjects[subjectId]) }}</span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <br><br><br><br><br>
        </div>
      </div>
    </div>


    <div slot="modal-area">
      <b-modal id="student-manage-modal" class="basic-modal student-manage-modal"
               v-bind:title="$t('reports.manage_students')">
        <div class="student-manage-table-container scroll-box">
          <table class="table">
            <thead>
            <tr>
              <th></th>
              <th class="typography--body-3 typography--color-secondary">
                {{ $t('reports.table.number') }}
              </th>
              <th class="typography--body-3 typography--color-secondary">
                {{ $t('reports.table.name') }}
              </th>
              <th class="typography--body-3 typography--color-secondary">
                {{ $t('reports.table.gender') }}
              </th>
            </tr>
            </thead>

            <tbody>
            <tr v-for="(student, index) in managingStudentList" v-bind:key="student.student_id">
              <td class="align-middle typography--body-3 typography--color-secondary">
                <div class="mdc-form-field">
                  <Checkbox v-on:change="selectStudent" v-bind:model-value="checkedStudents" v-bind:check-value="student" v-bind:id="`student-checkbox-${student.student_id}`">
                  </Checkbox>
                </div>
              </td>
              <td class="align-middle typography--body-3 typography--color-primary">{{ index + 1 }}</td>
              <td class="align-middle typography--body-3 typography--color-primary">{{ student.name }}</td>
              <td class="align-middle typography--body-3 typography--color-secondary">
                <div class="mdc-form-field">
                  <Radio v-on:change="selectStudentGender(student, 1)" v-bind:model-value="student.gender" v-bind:check-value="1" id="male-student">
                    <span slot="label">{{ $t('reports.gender.1') }}</span>
                  </Radio>

                  <Radio v-on:change="selectStudentGender(student, 2)" v-bind:model-value="student.gender" v-bind:check-value="2" id="female-student">
                    <span slot="label">{{ $t('reports.gender.2') }}</span>
                  </Radio>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <div slot="modal-footer" class="w-100">
          <button type="button"
                  class="float-left btn btn-outline-primary btn-fab btn-mini-fab mr-2"
                  v-on:click="moveStudentNumber('up')">
            <i class="material-icons">keyboard_arrow_up</i>
          </button>

          <button type="button"
                  class="float-left btn btn-outline-primary btn-fab btn-mini-fab"
                  v-on:click="moveStudentNumber('down')">
            <i class="material-icons">keyboard_arrow_down</i>
          </button>

          <button type="button"
                  class="btn btn-primary float-right close-btn"
                  v-on:click="updateStudents">
            {{ $t('common.save') }}
          </button>

          <button type="button"
                  class="btn btn-outline-primary float-right close-btn mr-2"
                  v-on:click="$root.$emit('hide::modal', 'student-manage-modal')">
            {{ $t('common.cancel') }}
          </button>
        </div>
      </b-modal>

      <b-modal id="recommend-content-modal" class="basic-modal"
               v-bind:title="`${this.$t('reports.go_to_recommend_contents')} | ${getTranslatedName(subjectMap[selectedSubjectId])}`">
        <div class="recommend-content-container">
          <div class="recommend-content-studentname">
            <div class="recommend-content-header-time">
              <img src="/static/images/time-icon.svg" v-if="getTotalDuration(studentToRecommend.submissions) !== 0">
              <img src="/static/images/time-gray-icon.svg" v-else>
              {{ formattedTime(getTotalDuration(studentToRecommend.submissions)) }}
            </div>

            <span class="typography--font-weight-bold typography--color-secondary"> {{ getNumStrTwoDigit(studentToRecommend.number) }} &nbsp; {{ studentToRecommend.name }}</span>
          </div>

          <div class="recommend-content-studentinfo">
            <div class="recommend-content-item-left">
              {{ $t('reports.table.score') }}
            </div>
            <div class="recommend-content-item-right color-000000">
              {{ getSubmissionSubjectScore(studentToRecommend.submissions, selectedSubjectId) }}
            </div>
            <div class="recommend-content-item-left">
              {{ $t('common.rank') }}
            </div>
            <div class="recommend-content-item-right color-000000">
              <span class="typography--font-weight-bold"
                    v-if="classSubjectScoreRanks.indexOf(getSubmissionSubjectScore(studentToRecommend.submissions, selectedSubjectId)) >= 0">
                {{ classSubjectScoreRanks.indexOf(getSubmissionSubjectScore(studentToRecommend.submissions, selectedSubjectId)) + 1 }}{{ $t('reports.rank_suffix') }}
              </span>
              <span class="typography--font-weight-bold" v-else>{{ classSubjectScoreRanks.length + 1 }}{{ $t('reports.rank_suffix') }}</span> / {{ studentList.length }}
            </div>
            <div class="recommend-content-item-left text-right">
              {{ $t('reports.table.complete_rate') }}
            </div>
            <div class="recommend-content-item-right typography--font-weight-bold color-000000 text-right">
              {{ getCompleteRateSubject(studentToRecommend.submissions, selectedSubjectId) }}%
            </div>
          </div>

          <div class="text-center pt-30 pb-20" v-if="getRecommendUnits(studentToRecommend).length === 0">
            {{ $t('reports.no_recommend_chapters') }}
          </div>
          <div v-else>
            <div class="recommend-content-chapter clickable"
                 v-for="unitId in getRecommendUnits(studentToRecommend)"
                 v-bind:key="unitId"
                 v-on:click="goToLibrary(selectedSubjectId, cls, unitId)"
                 v-show="units[unitId]">
              <div class="recommend-content-chapter-score">{{ $t('reports.table.score') }}&nbsp;&nbsp;
                <span class="typography--font-weight-bold recommend-content-chapter-score-number">
                  {{ getAverageScore(getSubmissionsOfUnit(studentToRecommend.submissions, unitId)) || 0 }}
                </span>
              </div>
              {{ getUnitLabel(units[unitId]) }}
            </div>
          </div>
        </div>
        <div slot="modal-footer" class="w-100">
          <button type="button"
                  class="btn btn-outline-primary float-right close-btn mr-2"
                  v-on:click="$root.$emit('hide::modal', 'recommend-content-modal')">
            {{ $t('common.close') }}
          </button>
        </div>
      </b-modal>

      <SelectAssignmentModal
        :assignment-list="assignmentsBySubjects[selectedSubjectId]"
        :pre-selected-list="selectedAssignmentList"
        :has-selected-all-assignments="hasSelectedAllAssignments"
        v-if="selectAssignmentModalIsShown"
        @cancel="selectAssignmentModalIsShown = false"
        @assignments-selected="onAssignmentsSelected"
      />
    </div>
  </MainLayout>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { isEmpty, keyBy, orderBy, sum, mean, cloneDeep, isEqual, isNil, uniq, map, filter } from 'lodash';
  import labels from '@/mixins/labels';
  import BarChart from '../components/BarChart';
  import LineChart from '../components/LineChart';
  import DoughnutChart from '../components/DoughnutChart';
  import SelectAssignmentModal from '../components/SelectAssignmentModal';

  export default {
    name: 'class-report',

    mixins: [
      labels,
    ],

    components: {
      BarChart,
      LineChart,
      DoughnutChart,
      SelectAssignmentModal,
    },

    data() {
      return {
        loading: false,
        cls: null,
        students: null,
        studentToRecommend: {},
        studentList: [],
        selectedSubjectId: 0,
        selectedReport: 1,
        selectedGraph: 1,
        selectedStudentReport: 1,
        managingStudentList: [],
        checkedStudents: [],
        assignments: [],
        selectedAssignmentList: [],
        hasSelectedAllAssignments: true,
        assignmentStats: {},
        allSubmissions: [],
        assignmentsBySubjects: {},
        submissionsBySubjects: {},

        averageScoreBySubjects: {},
        diffScoreBySubjects: {},
        averageDurationBySubjects: {},
        diffDurationBySubjects: {},
        averageSubmitrateBySubjects: {},
        diffSubmitrateBySubjects: {},

        viewMoreLength: 8,
        viewMoreNeedHelp: false,
        viewMoreTotalStudents: false,

        classScores: [],
        currentAvgScore: 0,
        diffAvgScore: 0,
        currentSubmissionRate: 0,
        diffSubmissionRate: 0,
        sortType: 'number',

        selectAssignmentModalIsShown: false,
      };
    },

    computed: {
      ...mapGetters([
        'managingClasses',
        'getRouteQuery',
        'coreConcepts',
        'subjectMap',
        'units',
      ]),

      subjectIds() {
        if (this.cls.school_name.includes('중학교')) {
          return [2, 5, 43, 44, 41, 42, 50, 51, 47, 48];
        }

        if (this.cls.grade >= 3 && this.cls.grade <= 6) {
          return [2, 3, 5, 41, 42, 50, 51, 47, 48];
        } else if (this.cls.grade >= 7 && this.cls.grade <= 9) {
          return [2, 5, 43, 44, 41, 42, 50, 51, 47, 48];
        }

        return [41, 42, 50, 51, 47, 48, 49];
      },

      selectedAssignmentsById() {
        return keyBy(this.selectedAssignmentList, 'id');
      },

      sortedStudentList() {
        if (this.sortType === 'number') {
          return orderBy(this.studentList, student => (
            student.number || 9999
          ), 'asc');
        }

        return orderBy(this.studentList, (student) => {
          const studentSubjectScore = this.getSubmissionSubjectScore(
            student.submissions, this.selectedSubjectId,
          );
          if (isNil(studentSubjectScore)) {
            return -1;
          }
          return studentSubjectScore;
        }, 'desc');
      },

      formattedClassName() {
        if (this.cls) {
          const year = this.cls.year;
          const schoolName = this.cls.school_name;
          const grade = this.cls.grade;
          const className = this.cls.name;

          return `${year} ${this.getShortenedString(schoolName, 15)} ${grade} - ${this.getShortenedString(className, 15)}`;
        }

        return '';
      },

      classScoreRanks() {
        return orderBy(this.classScores, null, 'desc');
      },

      classSubjectScoreRanks() {
        const classSubjectScores = [];
        this.studentList.forEach((student) => {
          const score = this.getSubmissionSubjectScore(student.submissions, this.selectedSubjectId);
          if (score !== null) {
            classSubjectScores.push(score);
          }
        });

        return orderBy(classSubjectScores, null, 'desc');
      },

      needHelpStudentList() {
        const studentList = this.studentList.filter((student) => {
          const averageScore = this.getSubmissionSubjectScore(
            student.submissions, this.selectedSubjectId);
          const classRank = this.classSubjectScoreRanks.indexOf(averageScore) + 1;

          // 과목 평균 점수가 49점 이하거나, 반 등수가 하위 30%이면서 점수가 60점 이하인 학생
          if (averageScore !== null && (averageScore <= 49 ||
              (classRank >= Math.floor((this.studentList.length * 2) / 3) && averageScore <= 60))) {
            return true;
          }
          return false;
        });

        if (this.sortType === 'number') {
          return orderBy(studentList, student => (student.number || 9999), 'asc');
        }
        return orderBy(studentList, student => (
          this.getSubmissionSubjectScore(student.submissions, this.selectedSubjectId)
        ), 'desc');
      },

      achievementDistributionCriteria() {
        return [100, 89, 79, 69, 59, -1];
      },

      dayDiffForWeek() {
        return [6, 0, 1, 2, 3, 4, 5];
      },

      achievementDistributionLabel() {
        const distributionLabel = [];

        for (let i = 0; i < this.achievementDistributionCriteria.length - 1; i += 1) {
          distributionLabel.push(`${this.achievementDistributionCriteria[i + 1] + 1}-${this.achievementDistributionCriteria[i]}`);
        }
        return distributionLabel;
      },

      achievementDistribution() {
        const distributionData = [0, 0, 0, 0, 0, 0];

        this.studentList.forEach((student) => {
          const score = this.getSubmissionSubjectScore(student.submissions, this.selectedSubjectId);
          if (score !== null) {
            for (let i = 1; i < this.achievementDistributionCriteria.length; i += 1) {
              if (score > this.achievementDistributionCriteria[i]) {
                distributionData[i - 1] += 1;
                break;
              }
            }
          }
        });

        return {
          labels: this.achievementDistributionLabel,
          datasets: [
            {
              data: distributionData,
              backgroundColor: '#00c896',
            },
          ],
        };
      },

      activeStudentData() {
        const activeStudent = [];

        this.studentList.forEach((student) => {
          const durations = [];
          const selectedSubmissions = (student.submissions || []).filter(submission => (
            !isNil(this.selectedAssignmentsById[submission.assignment_id])
          ));
          this.getSubmissionsThisWeek(selectedSubmissions).forEach((submission) => {
            if (submission.subject_id === this.selectedSubjectId) {
              durations.push(submission.duration);
            }
          });

          if (durations.length > 0) {
            activeStudent.push(student);
          }
        });

        const chartData = [];

        chartData.push(activeStudent.length);
        chartData.push(this.studentList.length - activeStudent.length);

        return {
          datasets: [
            {
              backgroundColor: ['#89d5ff', '#cccccc'],
              data: chartData,
            },
          ],
        };
      },

      trendData() {
        const trendLabel = [];
        const trendDataAchievement = [];
        const trendDataSubmissionRate = [];
        const now = new Date();
        const howManyWeeksToShow = 6;
        const subjectAssignmentList = this.assignmentsBySubjects[this.selectedSubjectId];
        const assignmentList = filter(subjectAssignmentList, assignment => (
          !isNil(this.selectedAssignmentsById[assignment.id])
        ));

        try {
          const totalAssignedCount = sum(
            assignmentList.map(assignment => (
              assignment.submissions.length
            )));

          for (let i = howManyWeeksToShow; i >= 0; i -= 1) {
            const date = new Date();
            date.setDate(now.getDate() - (7 * i));
            date.setHours(23);
            date.setMinutes(59);
            date.setSeconds(59);
            trendLabel.push(`${date.getMonth() + 1}${this.$t('common.month')} ${date.getDate()}${this.$t('common.day')}`);
            const submissions = [];
            assignmentList.forEach((assignment) => {
              assignment.submissions.filter((submission) => {
                if (submission.submitted_at) {
                  const submittedDate = new Date(submission.submitted_at);
                  if (submittedDate.getTime() <= date.getTime()) {
                    submissions.push(submission);
                    return true;
                  }
                }
                return false;
              });
            });
            trendDataSubmissionRate.push((submissions.length / totalAssignedCount) * 100);
            trendDataAchievement.push(this.getAverageScore(submissions));
          }
        } catch (err) {
          for (let i = howManyWeeksToShow; i >= 0; i -= 1) {
            trendDataSubmissionRate.push(0);
            trendDataAchievement.push(0);
            const date = new Date();
            date.setDate(now.getDate() - (7 * i));
            date.setHours(23);
            date.setMinutes(59);
            date.setSeconds(59);
            trendLabel.push(`${date.getMonth() + 1}${this.$t('common.month')} ${date.getDate()}${this.$t('common.day')}`);
          }
        }

        this.currentAvgScore = Math.round(trendDataAchievement[howManyWeeksToShow]);
        this.diffAvgScore = Math.round(trendDataAchievement[howManyWeeksToShow] -
          trendDataAchievement[howManyWeeksToShow - 1]);
        this.currentSubmissionRate = Math.round(trendDataSubmissionRate[howManyWeeksToShow]);
        this.diffSubmissionRate = Math.round(trendDataSubmissionRate[howManyWeeksToShow] -
          trendDataSubmissionRate[howManyWeeksToShow - 1]);

        return {
          labels: trendLabel,
          datasets: [
            {
              data: trendDataSubmissionRate,
              lineTension: 0,
              backgroundColor: 'rgba(0, 0, 0, 0)',
              borderColor: '#ffcd78',
              pointRadius: 5,
              pointBackgroundColor: '#ffcd78',
            },
            {
              data: trendDataAchievement,
              lineTension: 0,
              backgroundColor: 'rgba(0, 0, 0, 0)',
              borderColor: '#00c896',
              pointRadius: 5,
              pointBackgroundColor: '#00c896',
            },
          ],
        };
      },
    },

    methods: {
      ...mapActions([
        'setSelectedPreviewPageIndex',
        'setIsClassAssignmentPreview',
        'fetchTeacherAssignmentStats',
        'fetchAssignedCardPages',
        'setSelectedPreviewCard',
        'fetchClassAssignments',
        'manageClassStudents',
        'fetchClassStudents',
        'syncClassStudents',
        'setLibrartFilter',
        'fetchUnits',
      ]),

      isNil(value) {
        return isNil(value);
      },

      getNumStrTwoDigit(number) {
        if (number === null || number === undefined) {
          return '-';
        }

        if (number <= 9) {
          return `0${number}`;
        }
        return number;
      },

      formattedTime(duration) {
        if (!duration) {
          return '00h 00m';
        }
        return `${this.getNumStrTwoDigit(Math.floor(Math.abs(duration) / 3600))}h ${this.getNumStrTwoDigit(Math.floor(Math.abs(duration) / 60) % 60)}m`;
      },

      formattedDiff(number) {
        if (number >= 0) {
          return `+ ${this.getNumStrTwoDigit(number)}`;
        }
        return `- ${this.getNumStrTwoDigit(-number)}`;
      },

      getLearningElements(coreConcept) {
        if (!coreConcept) {
          return null;
        }

        return coreConcept.description;
      },

      selectStudent(checkedStudents) {
        this.checkedStudents = checkedStudents;
      },

      selectStudentGender(student, gender) {
        /* eslint-disable no-param-reassign */
        student.gender = gender;
      },

      reOrderManagingStudentList() {
        this.managingStudentList.forEach((student, i) => {
          student.number = i + 1;
        });
      },

      move(list, from, to) {
        if (to >= list.length || to < 0) {
          return from;
        }

        const item = list.splice(from, 1)[0];
        item.number = to + 1;
        list.splice(to, 0, item);

        return to;
      },

      moveStudentNumber(direction) {
        const usedPos = [];

        if (direction === 'up') {
          orderBy(this.checkedStudents, 'number', 'asc').forEach((student) => {
            const from = student.number - 1;
            const to = student.number - 2;

            if (usedPos.indexOf(to) === -1) {
              const pos = this.move(this.managingStudentList, from, to);
              usedPos.push(pos);
            } else {
              usedPos.push(from);
            }
          });
        } else {
          orderBy(this.checkedStudents, 'number', 'desc').forEach((student) => {
            const from = student.number - 1;
            const to = student.number;

            if (usedPos.indexOf(to) === -1) {
              const pos = this.move(this.managingStudentList, from, to);
              usedPos.push(pos);
            } else {
              usedPos.push(from);
            }
          });
        }

        this.reOrderManagingStudentList();
      },

      openStudentManageModal() {
        this.managingStudentList = orderBy(cloneDeep(this.studentList), 'number', 'asc');
        this.reOrderManagingStudentList();
        this.checkedStudents = [];

        this.$root.$emit('show::modal', 'student-manage-modal');
      },

      openRecommendContentModal() {
        this.$root.$emit('show::modal', 'recommend-content-modal');
      },

      updateStudents() {
        const modifiedStudents = this.managingStudentList.filter(student => (
          !isEqual(student, this.students[student.student_id])
        ))
          .map(student => ({
            student_id: student.student_id,
            class_id: student.class_id,
            number: student.number,
            gender: student.gender,
          }));

        const updateInfo = {
          students: modifiedStudents,
          classId: this.cls.id,
        };

        this.manageClassStudents(updateInfo)
          .then(() => {
            this.managingStudentList.forEach((student) => {
              this.students[student.student_id].number = student.number;
              this.students[student.student_id].gender = student.gender;
            });
          })
          .then(() => {
            this.$root.$emit('hide::modal', 'student-manage-modal');
          })
          .catch((err) => {
            this.$root.$emit('show::modal', 'basic-error-alert');
            return Promise.reject(err);
          });
      },

      getSubmittedSubmissions(submissions) {
        if (!submissions) {
          return [];
        }

        return submissions.filter(submission => (
          !!submission.is_submitted
        ));
      },

      getSubmissionSubjectScore(submissions, subjectId, subjectIdList) {
        if (!submissions) {
          return null;
        }

        const filtered = submissions.filter((submission) => {
          if (subjectId) {
            return (submission.subject_id === subjectId
              && !!submission.is_submitted
              && this.selectedAssignmentsById[submission.assignment_id]);
          }

          if (!isEmpty(subjectIdList)) {
            return subjectIdList.indexOf(submission.subject_id) !== -1 && !!submission.is_submitted;
          }

          return false;
        })
          .filter(submission => (
            submission.quiz_count > 0
          ));

        if (filtered.length === 0) {
          return null;
        }

        const scores = filtered.map(submission => (
          (submission.score / submission.total_score) * 100
        ));

        return parseInt(mean(scores), 10);
      },

      getAverageScore(submissions) {
        if (!submissions) {
          return null;
        }

        const filtered = submissions.filter(submission => (
          submission.quiz_count > 0
        ));

        if (filtered.length === 0) {
          return null;
        }

        const scores = this.getSubmittedSubmissions(filtered).map(submission => (
          (submission.score / submission.total_score) * 100
        ));

        if (scores.length === 0) {
          return null;
        }

        return parseInt(mean(scores), 10);
      },

      getAverageDuration(submissions) {
        if (!submissions) {
          return null;
        }

        const filtered = this.getSubmittedSubmissions(submissions).filter(submission => (
          submission.duration !== null && this.selectedAssignmentsById[submission.assignment_id]
        ));

        if (filtered.length === 0) {
          return null;
        }

        const durations = filtered.map(submission => (
          submission.duration
        ));

        return parseInt(mean(durations), 10);
      },

      getTotalDuration(submissions) {
        if (!submissions) {
          return null;
        }

        const filtered = this.getSubmittedSubmissions(submissions).filter(submission => (
          submission.duration !== null && this.selectedAssignmentsById[submission.assignment_id]
        ));

        if (filtered.length === 0) {
          return 0;
        }

        const durations = filtered.map(submission => (
          submission.duration
        ));

        return sum(durations);
      },

      getCompleteRate(submissions) {
        if (!submissions || submissions.length === 0) {
          return 0;
        }

        const submittedCount = this.getSubmittedSubmissions(submissions).length;
        const rate = (submittedCount / submissions.length) * 100;

        return parseInt(rate, 10);
      },

      getCompleteRateSubject(submissions, subjectId, subjectIdList) {
        if (!submissions || submissions.length === 0) {
          return 0;
        }

        const filtered = submissions.filter((submission) => {
          if (subjectId) {
            return (submission.subject_id === subjectId
              && this.selectedAssignmentsById[submission.assignment_id]);
          }

          if (!isEmpty(subjectIdList)) {
            return subjectIdList.indexOf(submission.subject_id) !== -1;
          }

          return false;
        });

        const submittedCount = this.getSubmittedSubmissions(filtered).length;
        const rate = (submittedCount / filtered.length) * 100;

        return parseInt(rate, 10);
      },

      getActiveStudents() {
        const now = new Date();
        now.setHours(0);
        now.setMinutes(0);
        now.setSeconds(0);

        const activeStudentList = this.studentList.filter((student) => {
          if (student.submissions) {
            for (let i = 0; i < student.submissions.length; i += 1) {
              if (student.submissions[i].subject_id ===
                this.selectedSubjectId && student.submissions[i].submitted_at) {
                const submittedDate = new Date(student.submissions[i].submitted_at);
                if (submittedDate.getTime() >= (now.getTime() -
                    (this.dayDiffForWeek[now.getDay()] * 24 * 60 * 60 * 1000))
                    && this.selectedAssignmentsById[student.submissions[i].assignment_id]) {
                  return true;
                }
              }
            }
          }
          return false;
        });

        return activeStudentList.length;
      },

      getSubmissionsUntilLastWeek(submissions) {
        if (submissions) {
          const now = new Date();
          now.setHours(0);
          now.setMinutes(0);
          now.setSeconds(0);

          const filtered = submissions.filter(submission => (
            !isNil(this.selectedAssignmentsById[submission.assignment_id])
          ))
          .filter((submission) => {
            const submittedDate = new Date(submission.submitted_at);
            if (submittedDate.getTime() < (now.getTime() -
                (this.dayDiffForWeek[now.getDay()] * 24 * 60 * 60 * 1000))) {
              return true;
            }
            return false;
          });

          return filtered;
        }

        return [];
      },

      getSubmissionsThisWeek(submissions) {
        if (submissions) {
          const now = new Date();
          now.setHours(0);
          now.setMinutes(0);
          now.setSeconds(0);

          const filtered = submissions.filter((submission) => {
            const submittedDate = new Date(submission.submitted_at);
            if (submittedDate.getTime() >= (now.getTime() -
                (this.dayDiffForWeek[now.getDay()] * 24 * 60 * 60 * 1000))) {
              return true;
            }
            return false;
          });

          return filtered;
        }

        return [];
      },

      getSubmissionsOfUnit(submissions, unitId) {
        return submissions.filter(submission =>
          (submission.subject_id === this.selectedSubjectId &&
            submission.unit_id === unitId));
      },

      openClassAssignmentPreview(assignment) {
        const cardClone = cloneDeep(assignment.assigned_card);

        cardClone.title += ` (${this.formattedClassName})`;

        this.fetchAssignedCardPages(assignment.id)
          .then((pages) => {
            const quizPages = pages.filter(page => (!!page.is_quiz));
            cardClone.pages = cloneDeep(quizPages);
          })
          .then(() => (
            this.setSelectedPreviewCard(cardClone)
          ))
          .then(() => (
            this.setSelectedPreviewPageIndex(0)
          ))
          .then(() => (
            this.setIsClassAssignmentPreview(true)
          ))
          .then(() => {
            this.$root.$emit('show::modal', 'card-preview-modal');
          })
          .catch((err) => {
            this.$root.$emit('show::modal', 'basic-error-alert');
            return Promise.reject(err);
          });
      },

      getRecommendUnits(student) {
        if (!student.submissions) {
          return [];
        }

        const unitList = [];

        student.submissions.forEach((submission) => {
          if (submission.subject_id === this.selectedSubjectId && submission.unit_id) {
            if (this.getAverageScore([submission]) !== null &&
                this.getAverageScore([submission]) <= 50 &&
                unitList.indexOf(submission.unit_id) === -1 &&
                this.units[submission.unit_id]) {
              unitList.push(submission.unit_id);
            }
          }
        });

        return unitList;
      },

      goToLibrary(selectedSubjectId, cls, unitId) {
        this.$root.$emit('hide::modal', 'recommend-content-modal');
        // TODO: should replace cls.grade with something else
        this.$router.push(`/library/store-cards?subject_id=${selectedSubjectId}&grade_id=${cls.grade}&unit_id=${unitId}`);
      },

      getShortenedString(string, maxLength) {
        if (string.length <= maxLength) {
          return string;
        }
        return `${string.substring(0, maxLength)}...`;
      },

      onAssignmentsSelected({ selectedList, isAll }) {
        if (isAll) {
          this.selectedAssignmentList = this.assignmentsBySubjects[this.selectedSubjectId] || [];
          this.hasSelectedAllAssignments = true;
        } else {
          const assignmentsById = keyBy(this.assignmentsBySubjects[this.selectedSubjectId], 'id');

          this.selectedAssignmentList = map(selectedList, id => (assignmentsById[id]));
          this.hasSelectedAllAssignments = false;
        }

        this.selectAssignmentModalIsShown = false;
      },
    },

    watch: {
      selectedSubjectId(subjectId) {
        this.selectedAssignmentList = this.assignmentsBySubjects[subjectId] || [];
        this.hasSelectedAllAssignments = true;
      },
    },

    created() {
      this.loading = true;
      const classId = this.$route.params.class_id;

      this.cls = this.managingClasses[classId];

      if (!isEmpty(this.cls)) {
        this.fetchClassStudents(this.cls.id)
          .then((studentList) => {
            if (!studentList || studentList.length === 0) {
              return this.syncClassStudents(this.cls.id);
            }

            return studentList;
          })
          .then((studentList) => {
            this.studentList = orderBy(studentList, student => (
              student.number || 9999
            ), 'asc');
            this.students = keyBy(this.studentList, 'student_id');
          })
          .then(() => {
            // TODO: should replace cls.grade with something else
            this.setLibrartFilter({ property: 'grade_id', value: this.cls.grade });
          })
          .then(() => (
            this.fetchTeacherAssignmentStats({ class_id: classId })
              .then((assignmentStats) => {
                this.assignmentStats = assignmentStats;

                return assignmentStats;
              })
          ))
          .then(assignmentStats => (
            this.fetchClassAssignments({ class_id: classId, per_page: assignmentStats.total_count })
          ))
          .then(assignments => (
            Promise.all(uniq(assignments.filter(assignment => (
              !isNil(assignment.assigned_card.subject_id) &&
              !isNil(assignment.assigned_card.grade_id)
            ))
            .map(assignment => (
              `${assignment.assigned_card.subject_id}&${assignment.assigned_card.grade_id}`
            )))
            .map((subjectGrade) => {
              const [subjectId, gradeId] = subjectGrade.split('&');

              return this.fetchUnits({
                subject_id: subjectId,
                grade_id: gradeId,
              });
            }))
            .then(() => (assignments))
          ))
          .then((assignments) => {
            this.assignments = assignments;
          })
          .then(() => {
            this.assignments.forEach((assignment) => {
              if (isEmpty(this.assignmentsBySubjects[assignment.assigned_card.subject_id])) {
                this.assignmentsBySubjects[assignment.assigned_card.subject_id] = [];
                this.submissionsBySubjects[assignment.assigned_card.subject_id] = [];
              }

              this.assignmentsBySubjects[assignment.assigned_card.subject_id].push(assignment);

              assignment.submissions.forEach((submission) => {
                this.submissionsBySubjects[assignment.assigned_card.subject_id].push(submission);
                this.allSubmissions.push(submission);

                if (this.students[submission.student_id]) {
                  if (isEmpty(this.students[submission.student_id].submissions)) {
                    this.students[submission.student_id].submissions = [];
                  }

                  this.students[submission.student_id].submissions.push(submission);
                }
              });
            });

            this.subjectIds.forEach((subjectId) => {
              this.averageScoreBySubjects[subjectId] =
                this.getAverageScore(this.submissionsBySubjects[subjectId]) || 0;
              this.diffScoreBySubjects[subjectId] = this.averageScoreBySubjects[subjectId] -
                this.getAverageScore(
                  this.getSubmissionsUntilLastWeek(this.submissionsBySubjects[subjectId]));

              this.averageDurationBySubjects[subjectId] =
                this.getAverageDuration(this.submissionsBySubjects[subjectId]);
              this.diffDurationBySubjects[subjectId] = this.averageDurationBySubjects[subjectId] -
                this.getAverageDuration(
                  this.getSubmissionsUntilLastWeek(this.submissionsBySubjects[subjectId]));

              this.averageSubmitrateBySubjects[subjectId] =
                this.getCompleteRate(this.submissionsBySubjects[subjectId]);
              this.diffSubmitrateBySubjects[subjectId] = this.averageSubmitrateBySubjects[subjectId] -
                this.getCompleteRate(
                  this.getSubmissionsUntilLastWeek(this.submissionsBySubjects[subjectId]));
            });
          })
          .then(() => {
            if (this.getRouteQuery.subject_id) {
              this.selectedSubjectId = Number(this.getRouteQuery.subject_id);
            } else {
              this.selectedSubjectId = this.subjectIds[0];
            }
            this.setLibrartFilter({ property: 'subject_id', value: this.selectedSubjectId });

            this.selectedAssignmentList = this.assignmentsBySubjects[this.selectedSubjectId];
            this.hasSelectedAllAssignments = true;

            this.loading = false;
          })
          .catch((err) => {
            this.$root.$emit('show::modal', 'basic-error-alert');
            return Promise.reject(err);
          });
      } else {
        // TODO when class not found
        this.loading = false;
        this.$root.$emit('show::modal', 'basic-error-alert');
      }
    },
  };
</script>

<style lang="scss">
  .color-000000 {
    color: #000000 !important;
  }

  .color-00c896 {
    color: #00c896 !important;
  }

  .color-f97e76 {
    color: #f97e76 !important;
  }

  .font-14 {
    font-size: 14px;
  }

  .class-manage-btn {
    position: absolute;
    right: 10px;
    top: 40px;
  }

  .class-report-menu-selected {
    display: inline-block;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.54);
    padding: 0px 5px;
    border-bottom: 2px solid #666666;
  }

  .class-report-menu-nonselected {
    display: inline-block;
    color: rgba(0, 0, 0, 0.54);
    padding: 0px 5px;
  }

  .student-report-select {
    display: inline-block;
    width: 180px;
    height: 58px;
    background-image: url('/static/images/class-st-01-btn.svg');
    background-size: cover;
    background-repeat: no-repeat;
    color: #ffffff;
    padding-top: 7px;
  }

  .student-report-nonselect {
    display: inline-block;
    width: 180px;
    height: 58px;
    background-image: url('/static/images/class-st-02-btn.svg');
    background-size: cover;
    background-repeat: no-repeat;
    color: rgba(0, 0, 0, 0.54);
    padding-top: 7px;
  }

  .select-subject-dropdown {
    position: absolute;
    display: inline-block;
    right: 124px;
    width: 150px !important;
  }

  .select-assignment-btn {
    position: absolute;
    top: 8px;
    right: 10px;
    width: 94px;
    border-radius: 2px;
    font-size: 12px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 18px;
    color: rgba(0, 0, 0, 0.54);
    border: 1px solid #d9d9d9;
  }

  .view-more-container {
    cursor: pointer;
    width: 100%;
    border: 1px solid #d9d9d9;
    padding: 5px 0px;
    font-weight: bold;
    color: #00c896;
  }

  .btn-selectgraph {
    font-size: 14px;
    font-weight: 400;
    margin-right: 10px;
    padding: 9px 20px;
    width: 108px;
    text-align: center;
    vertical-align: middle;
  }

  .graph-summary-stat-container {
    width: calc(100% - 227px);
    margin-right: 10px;
    padding: 24px 20px;
    .graph-header {
      padding-bottom: 30px;

      .graph-summary-stat {
        position: absolute;
        right: 40px;
        color: rgba(0, 0, 0, 0.54);

        .show-when-narrow {
          display: none;
        }

        .show-when-wide {
          display: inline-block;
        }

        .total-students-number {
          font-size: 20px;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.87);
        }

        .avg-score {
          display: inline-block;
          border-right: 2px solid #d9d9d9;
          padding-right: 20px;
          position: relative;

          .avg-score-text {
            font-size: 20px;
            font-weight: bold;
            color: #00c896;
          }
        }

        .avg-submit-rate {
          display: inline-block;
          padding-left: 20px;
          position: relative;

          .avg-submit-text {
            font-size: 20px;
            font-weight: bold;
            color: #ffcd78;
          }
        }
      }

      @media (max-width: 980px) {
        .graph-summary-stat {
          right: 20px;

          .show-when-narrow {
            display: inline-block;
          }

          .show-when-wide {
            display: none;
          }

          .avg-score {
            padding-right: 5px;
          }

          .avg-submit-rate {
            padding-left: 5px;
          }

          .diff-text {
            position: absolute;
            right: 10px;
            bottom: 1px;
            font-weight: bold;
          }
        }
      }
    }
  }

  .study-state {
    padding: 20px;
    color: rgba(0, 0, 0, 0.54);
    width: 217px;

    .study-state-title {
      font-size: 20px;
      color: rgba(0, 0, 0, 0.87);
      margin-bottom: 20px;
    }

    .study-state-time {
      position: relative;
      height: 190px;
      margin-bottom: 15px;

      .study-state-time-text1 {
        position: absolute;
        top: 30%;
        left: 0;
        right: 0;
      }

      .study-state-time-text2 {
        position: absolute;
        top: 50%;
        left: 0;
        right: 0;
        font-size: 12px;
      }
    }

    .active-legend {
      display: inline-block;
      width: 10px;
      height: 10px;
      background-color: #89d5ff;
      border-radius: 50%;
      margin-right: 10px;
    }

    .inactive-legend {
      display: inline-block;
      width: 10px;
      height: 10px;
      background-color: #cccccc;
      border-radius: 50%;
      margin-right: 10px;
    }

    .bold-number {
      font-size: 20px;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.87);
    }
  }

  .recommend-content-container {
    .recommend-content-studentname {
      position: relative;
      font-size: 18px;
      margin-bottom: 10px;

      .recommend-content-header-time {
        position: absolute;
        right: 0px;
        font-size: 14px;
      }
    }

    .recommend-content-studentinfo {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-bottom: 20px;

      .recommend-content-item-left {
        display: inline-block;
        width: 15%;
      }
      .recommend-content-item-right {
        display: inline-block;
        width: 16%;
      }
    }

    .recommend-content-chapter {
      position: relative;
      border: 1px solid #d9d9d9;
      padding: 10px 20px;
      margin-bottom: 10px;
      color: rgba(0, 0, 0, 0.87);

      .recommend-content-chapter-score {
        position: absolute;
        right: 20px;
        color: rgba(0, 0, 0, 0.54);
      }

      .recommend-content-chapter-score-number {
        color: #000000;
      }

      &:hover {
        border: 1px solid #00c896;
        color: #00c896;

        .recommend-content-chapter-score {
          color: #00c896;
        }

        .recommend-content-chapter-score-number {
          color: #00c896;
        }
      }

      &:active {
        border: 1px solid #009a87;
        color: #009a87;

        .recommend-content-chapter-score {
          color: #009a87;
        }

        .recommend-content-chapter-score-number {
          color: #009a87;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/app/classes/views/ClassReport.vue